var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EmailDeliveryTable',{attrs:{"fetchAction":"EmailDeliveryStore/getQueueList","resendEmailAction":"EmailDeliveryStore/resendEmail","deleteEmailAction":"EmailDeliveryStore/deleteEmail","placeholder":"No emails are queued.","autoRefresh":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }